<div class="ap-grid ap-grid-cols-2 ap-grid-cols-sm-1">
    <div>
        <ap-input-skeleton></ap-input-skeleton>
        <ap-paragraph-skeleton [rows]="2"></ap-paragraph-skeleton>
    </div>
</div>
<ap-button-skeleton class="ap-sign__browser-skeleton_button"></ap-button-skeleton>
